import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-grid",
  "use": "svg_i-grid-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_i-grid\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 14v-2h2v2h-2zm0-8h2v2h-2V6zm0-6h2v2h-2V0zM6 2V0h2v2H6zM0 12h2v2H0v-2zm0-6h2v2H0V6zm0-6h2v2H0V0zm8 8H6V6h2v2zm0 6H6v-2h2v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol